import type { SharableOpportunity } from 'backend/types'
import { customSearchFilter } from '../-components/CustomSearch'

/** 検索対象のフィールド */
const SEARCHABLE_FIELDS: (keyof SharableOpportunity)[] = [
  'customer_issue',
  'proposal_summary',
  'background',
  'description',
  'trigger',
  'information_route',
  'shift_service_name',
  'shift_service_categories_name',
  'reason_for_negotiation',
]

export function filterPublicOpportunities(
  opportunities: SharableOpportunity[],
  searchText: string,
  customSearchQuery: string,
  customSearchExclude: string,
): SharableOpportunity[] {
  let filtered = opportunities

  // シンプル検索（テキストボックス）
  if (searchText) {
    const lowerSearch = searchText.toLowerCase()
    filtered = filtered.filter((opp) => {
      return SEARCHABLE_FIELDS.some((field) =>
        String(opp[field] || '')
          .toLowerCase()
          .includes(lowerSearch),
      )
    })
  }

  // カスタム検索（含む/含まない）
  if (customSearchQuery || customSearchExclude) {
    filtered = customSearchFilter(filtered, customSearchQuery, customSearchExclude, SEARCHABLE_FIELDS)
  }

  return filtered
}
